import React, { useState, useEffect, useRef } from "react";
import { Checkbox } from "semantic-ui-react";

import { getComponentValue } from "./Config";

function Switch(props) {
    const [state, setState] = useState(props.data.value);
    const lang = props.lang;
    const interval = useRef(null);

    useEffect(() => {
        if (props.data.id === "formatTime") {
            if (interval.current === null) {
                updateState();
            }
        }
    });

    useEffect(() => {
        setState(props.data.value);
    }, [props])

    const updateState = () => interval.current = setInterval(() => {
        setState(getComponentValue("formatTime"));
    }, 500)

    function onChangeSwitch() {
        props.onChange(props.data.id, !state);
        setState(!state);
    }

    return (
        <>
            <label htmlFor={props.data.id}>{props.data.description[lang]}</label>
            <div className="right">
                <label htmlFor={props.data.id}>{props.data.option_1[lang]}&nbsp;&nbsp;</label>
                <Checkbox toggle id={props.data.id} label={props.data.option_2[lang]} checked={state} onChange={onChangeSwitch} />
            </div>
        </>
    );
}

export default Switch;